import React from 'react';
import Swal from "sweetalert2";
import SuccessAlert from './SuccessAlert';
import imgCheck from "./img/check.png"
import QRCode from "react-qr-code";



function ConfirmationAlert(title, text, setPageLoader) {
    if (title == undefined || text == undefined) {
        title = 'ORDEN: 0000'
        text = 'Total: $0.00'
    }


    return (
        //We show a loading alert 
        Swal.fire({
            title: title,
            text: text,
            imageUrl: imgCheck,
            imageWidth: 200,
            imageHeight: 200,
            confirmButtonText: 'Crear nueva orden',
            imageAlt: 'Custom image',
            html:<h1 value="Hola Mundo" size={256} bgColor="#282c34" fgColor="#fff" level="H" />,
            allowOutsideClick: () => {
                
            }
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                SuccessAlert("Transaccion finalizada con exito.")
                setPageLoader(1)
            } 
          })

         
    )
}

export default ConfirmationAlert